import { useState } from 'react';

interface UseTestBatchConfirmDialogArgs {
  onCancel: () => void;
  onConfirm: () => void;
}

export interface UseTestBatchConfirmDialogResult {
  acknowledged: boolean;
  setAcknowledged: (value: boolean) => void;
  handleClose: () => void;
  handleConfirm: () => void;
}

/**
 * Owns the "I understand" acknowledgement checkbox state and resets it whenever
 * the dialog is dismissed or confirmed, so a reopened dialog always starts
 * unchecked.
 */
export const useTestBatchConfirmDialog = ({
  onCancel,
  onConfirm,
}: UseTestBatchConfirmDialogArgs): UseTestBatchConfirmDialogResult => {
  const [acknowledged, setAcknowledged] = useState(false);

  const handleClose = () => {
    setAcknowledged(false);
    onCancel();
  };

  const handleConfirm = () => {
    setAcknowledged(false);
    onConfirm();
  };

  return { acknowledged, setAcknowledged, handleClose, handleConfirm };
};
